import { Note } from "tonal";

export function convertToSharp(note: string) {
    const enharmonic = Note.enharmonic(note);
    if (enharmonic.includes("#")) {
        return enharmonic;
    }
    return note;
}